import React from 'react';
import * as vars from './variables';
import { __ } from '../../../../utils/translation-service';
import { PhoneIcon } from './Icons/PhoneIcon';
import { EnvelopeIcon } from './Icons/EnvelopeIcon';
import { Link } from './Link';

const style: any = {
    contactButton: {
        padding: '10px 0px 6px',
        width: '48%',
        maxWidth: 140,
        textAlign: 'center',
        background: vars.acqa,
        color: vars.white,
        borderRadius: '5px',
        flex: '0 0 auto',
    },
    contactButtonIcon: {
        fill: vars.white,
    },
    contactButtonText: {
        fontSize: '15px',
        display: 'block',
    },
    contactButtonsWrapper: {
        display: 'flex',
        width: '100%',
        padding: '10px 5% 25px',
        justifyContent: 'center',
    },
};
interface IStateProps {
    phoneNumber: string;
}
//@ts-ignore
type Props = IStateProps;
export const ContactButtons = () => {
    const TrackableLinkCallUs = Link;
    const TrackableLinkWriteUs = Link;

    return (
        <div style={style.contactButtonsWrapper}>
            <TrackableLinkCallUs
                style={{ ...style.contactButton, ...{ marginRight: 10 } }}
                href={`tel:<r hidden>phonelead</r>`}
                {...({} as any)}
            >
                {/* added empty object to fix missing values in type  */}
                <PhoneIcon
                    style={style.contactButtonIcon}
                    width={28}
                    height={28}
                    {...({} as any)}
                />
                <span style={style.contactButtonText}>{__('callUs')}</span>
            </TrackableLinkCallUs>
            <TrackableLinkWriteUs
                style={style.contactButton}
                href={`mailto:${__('infoEmail')}`}
                {...({} as any)}
            >
                {/* added empty object to fix missing values in type  */}
                <EnvelopeIcon
                    style={style.contactButtonIcon}
                    width={28}
                    height={28}
                    {...({} as any)}
                />
                <span style={style.contactButtonText}>{__('writeUs')}</span>
            </TrackableLinkWriteUs>
        </div>
    );
};
